<template>
  <div class="collection">
    <div class="collection-title">
      <!-- <h2>{{ collectionTitle }}</h2> -->
    </div>
    <div v-if="screenContent.length === 0">
      <GridLayoutPlaceholder  :displayType="'LANDSCAPE'" ></GridLayoutPlaceholder>
    </div>
    <Grid :contents="screenContent"  :displayType="'LANDSCAPE'"  :playerInstance="playerInstance" :isScrollable="isScrollable" @loadMore="loadMoreContents()" v-else></Grid>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/eventBus";
import Utility from "@/mixins/Utility.js";
import { store } from "@/store/store";


export default {
  props: {
    playerInstance: {
      type: Object,
    }
  },
  data() {
    return {
      loader: true,
      screenContent: [],
      errorMessage: null,
      localDisplayLang: null,
      page: 1,
      isScrollable: false,
      screen: false,
      collectionTitle: ''
    };
  },
  computed: {
    ...mapGetters(["appConfig"]),
  },
  watch: {
    $route() {
      console.log("Route changed, resetting screenContent and page");
      this.screenContent = [];
      this.page = 1;
      this.categoryList();
    },
  },
  created() {
    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode") || "en";
    this.localDisplayLang = this.localDisplayLang === "eng" ? "en" : this.localDisplayLang;
    console.log("Created: localDisplayLang set to:", this.localDisplayLang);
  },
  mounted() {
    this.collectionTitle = this.$route?.params?.id;
    console.log("Mounted: collectionTitle set to:", this.collectionTitle);
    this.categoryList();
     
  },
  methods: {

    loadMoreContents() {
      console.log("loadMoreContents called, incrementing page to:", this.page + 1);
      this.loader = true;
      this.page = this.page + 1;
      // this.loadContent();
      this.categoryList()
    },
    categoryList() {
      let payload = {
      endpoint: "subscriber/v1/content",
      params : {    
      objecttype : "EPGPROGRAMME",
      channelid : this.collectionTitle,
      orderby :   {"publishtime":"DESC"},
      page    : this.page,
      displaylanguage: this.localDisplayLang
      }
    }
    console.log('printpayload',payload)
      store
        .dispatch("contentList", payload)
        .then((response) => {
          if (!response.data.reason) {
            this.screenContent = [...this.screenContent, ...response.data.data];
            this.isScrollable = response.data.totalcount > this.screenContent.length;
            this.loader = false;
            console.log("Updated screenContent:", this.screenContent);
          } else {
            console.error("contentList failed, reason:", response.data.reason);
            this.errorMessage = response.data.reason;
            this.loader = false;
          }
        })
        .catch((error) => {console.log(error, 'error')});
    },
  },
  components: {
    Grid: () => import(/* webpackChunkName: "Grid" */ "@/components/Templates/GridLayout.vue"),
    GridLayoutPlaceholder: () => import(/* webpackChunkName: "gridplaceholder" */ "@/components/placeholders/GridLayoutPlaceholder.vue"),
  },
  beforeDestroy() {
    console.log("beforeDestroy: Cleaning up screenContent and event listeners");
    this.screenContent = [];
    eventBus.$off("check-for-series-route");
  },
  mixins: [Utility],
};
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";
@import "./collection.scss";

.collection {
  width: clamp(2rem, 100%, 95%);
  margin: 4rem auto auto auto; 
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .collection-title {
    padding: 0.5rem 2rem;
    text-align: center;
    text-transform: uppercase;
    opacity: 0.7;
  }
  .gridMainLayout {
    padding-top: 0 !important;
  }
}

@media screen and (max-width:1023px) {
  .collection {
    margin-top: 4rem;
  }
}
</style>